<template>
  <transition name="modal-fade">
    <div
      v-if="show"
      :class="modalClassName"
      transition="modal"
      @mousedown.left="onBackDropClick"
    >
      <div
        ref="modal"
        :class="modalContainerClassName"
        role="dialog"
        aria-modal="true"
        @mousedown.left.stop
      >
        <button
          ref="closeButton"
          class="close-button"
          :aria-label="$t('RESOLVE_MODAL.CLOSE_BUTTON')"
          @click="close"
        >
          <fluent-icon icon="dismiss" size="20" />
        </button>
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
import FluentIcon from 'shared/components/FluentIcon/Index.vue';
import { createFocusTrap } from 'focus-trap';

export default {
  name: 'Modal',
  components: { FluentIcon },
  props: {
    closeOnBackdropClick: {
      type: Boolean,
      default: true,
    },
    show: Boolean,
    onClose: {
      type: Function,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    modalType: {
      type: String,
      default: 'centered',
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      focusTrap: createFocusTrap(this.$refs.modal, {
        initialFocus: this.$refs.closeButton,
      }),
    };
  },
  computed: {
    modalContainerClassName() {
      let className = 'modal-container skip-context-menu';
      if (this.fullWidth) {
        return `${className} modal-container--full-width`;
      }

      return `${className} ${this.size}`;
    },
    modalClassName() {
      const modalClassNameMap = {
        centered: '',
        'right-aligned': 'right-aligned',
      };

      return `modal-mask skip-context-menu ${
        modalClassNameMap[this.modalType] || ''
      }`;
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.focusTrap = this.focusTrap.updateContainerElements(
            this.$refs.modal
          );
          this.focusTrap.activate();
        });
      } else {
        this.focusTrap.deactivate();
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', e => {
      if (this.show && e.code === 'Escape') {
        this.onClose();
      }
    });
  },
  methods: {
    close() {
      this.onClose();
    },
    onBackDropClick() {
      if (this.closeOnBackdropClick) {
        this.onClose();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';

.modal-container--full-width {
  align-items: center;
  border-radius: 0;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.modal-mask.right-aligned {
  justify-content: flex-end;

  .modal-container {
    border-radius: 0;
    height: 100%;
    width: 48rem;
  }
}
.modal-big {
  width: 60%;
}
.modal-biggest {
  width: 80%;
}
.rtl-direction-widget {
  .modal-container {
    direction: rtl;
  }
  .close-button {
    left: $space-slab;
    right: unset;
  }
}
.close-button {
  position: absolute;
  top: $space-slab;
  right: $space-slab;
  outline: none;
}
</style>
